export default __webpack_public_path__ + "static/media/PRESCRICOES.41b6ef36.webp";